module.exports = __webpack_public_path__ + "static/media/code.b0af760e.svg";